import React, { Component } from "react";
import { Col, Card, Form } from "antd";
import _ from "lodash";

class RuangNego extends Component {
  state = {
    calculation: [],
  };

  // ***
  // Perhitungan Update Ketika User Input Harga Final Approval
  // updateCOGS = Harga Final Approval (input user) -
  //              (Harga Final Approval or Koreksi MRP or Harga Final Appraisal)
  //              + COGS (old)
  // updateNBPT = Proyeksi Harga Jual - updateCOGS
  //
  // Jika tidak ada input User, maka COGS dan NBPT menggunakan data di calculation
  // ***
  getUpdatePrice(type) {
    let updateCOGS;
    let updateNBPT;
    let { calculation } = this.props;

    //Get IDX
    const idxCOGS = _.findIndex(calculation, { name: "COGX + OPEX" });
    const idxNBPT = _.findIndex(calculation, { name: "Proyeksi NPBT AAT" });

    if (calculation[idxNBPT] && calculation[idxCOGS] && this.props.finalPrice) {
      const proyeksiHargaJual = this.props.getValue(
        calculation,
        "name",
        "Proyeksi Harga Jual"
      );

      if (proyeksiHargaJual && proyeksiHargaJual !== "N/A") {
        const finalPrice = this.getFinalPrice(calculation);

        //Update COGS
        updateCOGS =
          this.props.finalPrice - finalPrice + calculation[idxCOGS].price;

        // Update NBPT AAT
        updateNBPT = proyeksiHargaJual - updateCOGS;
      } else {
        //Jika Proyeksi Harga jual N/A
        updateCOGS = this.props.getValue(calculation, "name", "COGX + OPEX");
        updateNBPT = this.props.getValue(
          calculation,
          "name",
          "Proyeksi NPBT AAT"
        );
      }
    } else {
      //Jika User belum input Harga Final
      updateCOGS = this.props.getValue(calculation, "name", "COGX + OPEX");
      updateNBPT = this.props.getValue(
        calculation,
        "name",
        "Proyeksi NPBT AAT"
      );
    }

    if (type === "COGS") return updateCOGS;
    return updateNBPT;
  }

  // Mendapatkan Harga Final Approval or Koreksi MRP or Harga Final Appraisal
  getFinalPrice(calculation) {
    let hargaFinal = 0;

    const hargaFinalApproval = _.find(calculation, {
      name: "Harga Final Approval",
    });

    //Harga Final Approval
    if (hargaFinalApproval) {
      hargaFinal = hargaFinalApproval.price || 0;
    } else {
      //Koreksi MRP
      const koreksiMrp = _.find(calculation, { name: "Koreksi MRP" });
      if (koreksiMrp) {
        hargaFinal = koreksiMrp.price || 0;
      } else {
        // Harga Final Appraisal
        const hargaFinalAppraisal = _.find(calculation, {
          name: "Harga Final",
        });
        if (hargaFinalAppraisal) {
          hargaFinal = hargaFinalAppraisal.price || 0;
        }
      }
    }

    return hargaFinal;
  }

  render() {
    const { formatRupiah, getValue, calculation } = this.props;
    return calculation ? (
      <Col xs={24} md={12}>
        <Card title="Gross Profit AAT">
          {/* {["Proyeksi Harga Jual", "COGX + OPEX", "Proyeksi NPBT AAT"].map(
            (v, i) => (
              <Form.Item label={v} key={v}>
                <span className="ant-form-text form-text-mod">
                  {formatRupiah(getValue(calculation, "name", v))}
                </span>
              </Form.Item>
              )
            )} */}

          <Form.Item label={"Proyeksi Harga Jual"}>
            <span className="ant-form-text form-text-mod">
              {formatRupiah(
                getValue(calculation, "name", "Proyeksi Harga Jual")
              )}
            </span>
          </Form.Item>

          <Form.Item label={"COGS + OPEX"}>
            <span className="ant-form-text form-text-mod">
              {formatRupiah(this.getUpdatePrice("COGS"))}
            </span>
          </Form.Item>

          <Form.Item label={"Proyeksi NPBT AAT"}>
            <span className="ant-form-text form-text-mod">
              {formatRupiah(this.getUpdatePrice("Proyeksi NPBT AAT"))}
            </span>
          </Form.Item>

          {getValue(calculation, "name", "Total Benefit TI") ? (
            <Form.Item label="Total Benefit TI">
              <span className="ant-form-text form-text-mod">
                {formatRupiah(
                  getValue(calculation, "name", "Total Benefit TI")
                )}
              </span>
            </Form.Item>
          ) : null}
        </Card>
      </Col>
    ) : null;
  }
}

export default RuangNego;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/GrossProfitAat.js